"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ppsx = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const PpsxSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M4.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H4.75a.25.25 0 0 0-.25.25v19.5c0 .137.112.25.25.25"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M19.147 6.5 15 2.354V6.25c0 .138.113.25.25.25z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M19.78 6.427 15.073 1.72a.76.76 0 0 0-.53-.22H4.75a.75.75 0 0 0-.75.75v19.5c0 .413.337.75.75.75h14.5a.75.75 0 0 0 .75-.75V6.957c0-.2-.078-.388-.22-.53M15 2.354 19.147 6.5H15.25a.25.25 0 0 1-.25-.25zM4.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H4.75a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    stroke: "#C8C6C4",
    strokeLinejoin: "round",
    d: "M14.75 14.75h-5.5a1 1 0 0 1-1-1v-5h7.5v5a1 1 0 0 1-1 1Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#C8C6C4",
    d: "M16.75 9a.25.25 0 0 0 0-.5zm-9.5-.5a.25.25 0 0 0 0 .5zm2.25 4.75a.25.25 0 0 0 .5 0zm.5-3a.25.25 0 0 0-.5 0zm6.75-1.75h-9.5V9h9.5zM10 13.25v-3h-.5v3z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    stroke: "#F5BA9D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 13.25v-2.5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    stroke: "#C8C6C4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.751 13.25v-2"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    stroke: "#F5BA9D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.251 13.25v-1.5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#C8C6C4",
    fillRule: "evenodd",
    d: "M12.5 15h-1v.5h-.75a.25.25 0 1 0 0 .5h2.5a.25.25 0 1 0 0-.5h-.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#D04727",
    d: "M8 18.75a.25.25 0 0 0 .5 0zm.5-2a.25.25 0 0 0-.5 0zm-1.488.573a.25.25 0 1 0 .354.354zm1.238-.883.177-.177a.25.25 0 0 0-.354 0zm.883 1.237a.25.25 0 0 0 .354-.354zM8.5 18.75v-2H8v2zm-1.134-1.073 1.06-1.06-.353-.354-1.06 1.06zm.707-1.06 1.06 1.06.354-.354-1.06-1.06-.354.353"
  })]
});
const Ppsx = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: PpsxSvg
}));
exports.Ppsx = Ppsx;